<script setup>
import { ref } from "vue";
import App from "components/App";

const props = defineProps(["authEmail", "loginEmail"]);

const busy = ref(false);
const showDialog = ref(false);

let promise = null;
let promiseResolve = null;
let promiseReject = null;

function cancel() {
	promise = null;

	if (promiseReject)
		promiseReject();

	showDialog.value = false;
}

function login(email) {
	promise = null;

	if (props.authEmail && props.authEmail.toLowerCase() !== email.toLowerCase())
		location.reload();
	else if (promiseResolve)
		promiseResolve();

	showDialog.value = false;
}

window.$vixLogin = () => {
	if (promise) // return existing promise if already attempted login
		return promise;

	showDialog.value = true;

	promise = new Promise((resolve, reject) => {
		promiseResolve = resolve;
		promiseReject = reject;
	});

	return promise;
};
</script>

<template>
	<UiDialog v-if="showDialog" :modal="busy" persist @close="cancel()">
		<App v-model:busy="busy" :email="loginEmail" @login="login"/>
	</UiDialog>
</template>
